export * from './delete-erforderliches-dokument.component';
export * from './delete-erforderliches-dokument.component.module';